import { ldJSON } from '~/scripts/article';

export default async ({ $api, $dateTime, $deserialize, $railsHost, route, store }) => {
  const locale = route.query.locale;
  await $api(`media/guides/${route.params.slug}`, { locale }).then(guide => {
    store.commit('blog/setGuide', guide);
    const breadcrumbs = [['i18n/home', '/'],
                         ['i18n/guides', '/guides/'],
                         [guide.category.description, guide.category.path],
                         guide.title];
    const card = guide.twitter_image ? (guide.twitter_image.webp || guide.twitter_image.fallback) : null;
    const metaTagOptions = { card, description: guide.sub_title, title: guide.title, ogType: 'article' };
    if (guide.is_video && guide.video_url) {
      metaTagOptions.videoUrl = guide.video_url;
    }
    metaTagOptions.title = guide.meta_title || guide.title;
    metaTagOptions.description = guide.meta_description || guide.title;
    route.meta[0] = { ...route.meta[0], ...{ breadcrumbs, ldJSON: ldJSON(guide, $dateTime, $railsHost()), metaTagOptions } };
    store.commit('pageContent/setHead', { description: guide.sub_title, title: guide.title });
  });
};
